/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketplace,
    AdminMarketplaceFromJSON,
    AdminMarketplaceFromJSONTyped,
    AdminMarketplaceToJSON,
} from './AdminMarketplace';
import {
    AdminProductDetailGroupSale,
    AdminProductDetailGroupSaleFromJSON,
    AdminProductDetailGroupSaleFromJSONTyped,
    AdminProductDetailGroupSaleToJSON,
} from './AdminProductDetailGroupSale';
import {
    AdminProductListAnalytics,
    AdminProductListAnalyticsFromJSON,
    AdminProductListAnalyticsFromJSONTyped,
    AdminProductListAnalyticsToJSON,
} from './AdminProductListAnalytics';
import {
    AdminProductListImage,
    AdminProductListImageFromJSON,
    AdminProductListImageFromJSONTyped,
    AdminProductListImageToJSON,
} from './AdminProductListImage';
import {
    AdminProductListOrders,
    AdminProductListOrdersFromJSON,
    AdminProductListOrdersFromJSONTyped,
    AdminProductListOrdersToJSON,
} from './AdminProductListOrders';
import {
    AdminProductStatus,
    AdminProductStatusFromJSON,
    AdminProductStatusFromJSONTyped,
    AdminProductStatusToJSON,
} from './AdminProductStatus';
import {
    ProductConsistency,
    ProductConsistencyFromJSON,
    ProductConsistencyFromJSONTyped,
    ProductConsistencyToJSON,
} from './ProductConsistency';

/**
 * 
 * @export
 * @interface AdminProductList
 */
export interface AdminProductList {
    /**
     * Analytics is the price analytics of the live listings; only for products
     * in sale (active, with a listing) that the worker has analyzed.
     * @type {AdminProductListAnalytics}
     * @memberof AdminProductList
     */
    analytics?: AdminProductListAnalytics;
    /**
     * 
     * @type {string}
     * @memberof AdminProductList
     */
    asin?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductList
     */
    category: string;
    /**
     * 
     * @type {ProductConsistency}
     * @memberof AdminProductList
     */
    consistency: ProductConsistency;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminProductList
     */
    consistencyDetails?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminProductList
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductList
     */
    deletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductList
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductList
     */
    groupSaleId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductList
     */
    id: string;
    /**
     * 
     * @type {Array<AdminProductListImage>}
     * @memberof AdminProductList
     */
    images?: Array<AdminProductListImage>;
    /**
     * 
     * @type {number}
     * @memberof AdminProductList
     */
    listingNumber: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductList
     */
    lowestResalePrice?: string;
    /**
     * 
     * @type {Array<AdminMarketplace>}
     * @memberof AdminProductList
     */
    marketplaces?: Array<AdminMarketplace>;
    /**
     * 
     * @type {string}
     * @memberof AdminProductList
     */
    msrp: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductList
     */
    name: string;
    /**
     * 
     * @type {Array<AdminProductListOrders>}
     * @memberof AdminProductList
     */
    orders?: Array<AdminProductListOrders>;
    /**
     * 
     * @type {number}
     * @memberof AdminProductList
     */
    palletOrderID?: number;
    /**
     * 
     * @type {AdminProductDetailGroupSale}
     * @memberof AdminProductList
     */
    productGroupSale?: AdminProductDetailGroupSale;
    /**
     * 
     * @type {string}
     * @memberof AdminProductList
     */
    purchasePrice: string;
    /**
     * 
     * @type {AdminProductStatus}
     * @memberof AdminProductList
     */
    status: AdminProductStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminProductList
     */
    updatedAt?: string;
}



export function AdminProductListFromJSON(json: any): AdminProductList {
    return AdminProductListFromJSONTyped(json, false);
}

export function AdminProductListFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'analytics': !exists(json, 'analytics') ? undefined : AdminProductListAnalyticsFromJSON(json['analytics']),
        'asin': !exists(json, 'asin') ? undefined : json['asin'],
        'category': json['category'],
        'consistency': ProductConsistencyFromJSON(json['consistency']),
        'consistencyDetails': !exists(json, 'consistencyDetails') ? undefined : json['consistencyDetails'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : json['deletedAt'],
        'description': json['description'],
        'groupSaleId': !exists(json, 'groupSaleId') ? undefined : json['groupSaleId'],
        'id': json['id'],
        'images': !exists(json, 'images') ? undefined : ((json['images'] as Array<any>).map(AdminProductListImageFromJSON)),
        'listingNumber': json['listingNumber'],
        'lowestResalePrice': !exists(json, 'lowestResalePrice') ? undefined : json['lowestResalePrice'],
        'marketplaces': !exists(json, 'marketplaces') ? undefined : ((json['marketplaces'] as Array<any>).map(AdminMarketplaceFromJSON)),
        'msrp': json['msrp'],
        'name': json['name'],
        'orders': !exists(json, 'orders') ? undefined : ((json['orders'] as Array<any>).map(AdminProductListOrdersFromJSON)),
        'palletOrderID': !exists(json, 'palletOrderID') ? undefined : json['palletOrderID'],
        'productGroupSale': !exists(json, 'productGroupSale') ? undefined : AdminProductDetailGroupSaleFromJSON(json['productGroupSale']),
        'purchasePrice': json['purchasePrice'],
        'status': AdminProductStatusFromJSON(json['status']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
    };
}

export function AdminProductListToJSON(value?: AdminProductList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'analytics': AdminProductListAnalyticsToJSON(value.analytics),
        'asin': value.asin,
        'category': value.category,
        'consistency': ProductConsistencyToJSON(value.consistency),
        'consistencyDetails': value.consistencyDetails,
        'createdAt': value.createdAt,
        'deletedAt': value.deletedAt,
        'description': value.description,
        'groupSaleId': value.groupSaleId,
        'id': value.id,
        'images': !value.images ? undefined : ((value.images as Array<any>).map(AdminProductListImageToJSON)),
        'listingNumber': value.listingNumber,
        'lowestResalePrice': value.lowestResalePrice,
        'marketplaces': !value.marketplaces ? undefined : ((value.marketplaces as Array<any>).map(AdminMarketplaceToJSON)),
        'msrp': value.msrp,
        'name': value.name,
        'orders': !value.orders ? undefined : ((value.orders as Array<any>).map(AdminProductListOrdersToJSON)),
        'palletOrderID': value.palletOrderID,
        'productGroupSale': AdminProductDetailGroupSaleToJSON(value.productGroupSale),
        'purchasePrice': value.purchasePrice,
        'status': AdminProductStatusToJSON(value.status),
        'updatedAt': value.updatedAt,
    };
}

